import { __extends } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';
import initSchemaLogger from '@wix/bi-logger-settings';
import { BIContext } from './BIContext';
var formatValueForEvent = function (value) {
    return typeof value !== 'string' ? JSON.stringify(value) : value;
};
var BIProvider = /** @class */ (function (_super) {
    __extends(BIProvider, _super);
    function BIProvider(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.settingsChanged = function (_a) {
            var parameter = _a.parameter, value = _a.value;
            _this.logger.settingsChanged({
                parameter: parameter,
                value: formatValueForEvent(value),
                category: formatValueForEvent(_this.state.currentCategory),
            });
        };
        _this.settingsTabClicked = function (_a) {
            var tabName = _a.tabName;
            _this.setState({ currentCategory: tabName });
            _this.logger.settingsTabClicked({ tabName: formatValueForEvent(tabName) });
        };
        _this.state = {
            currentCategory: null,
        };
        if (props.Wix && props.config) {
            var factory = iframeAppBiLoggerFactory(props.Wix);
            _this.logger = initSchemaLogger(factory)();
            _this.logger.util.updateDefaults({
                appName: props.config.appName,
                componentName: props.config.componentName,
                componentId: props.config.componentId,
                origin: props.config.origin,
                isMobile: (_a = props.isMobile) !== null && _a !== void 0 ? _a : false,
            });
        }
        return _this;
    }
    BIProvider.prototype.render = function () {
        if (!this.logger) {
            return this.props.children;
        }
        return (React.createElement(BIContext.Provider, { value: {
                settingsTabClicked: this.settingsTabClicked,
                settingsChanged: this.settingsChanged,
            } }, this.props.children));
    };
    BIProvider.propTypes = {
        Wix: PropTypes.object,
        isMobile: PropTypes.bool,
    };
    return BIProvider;
}(React.Component));
export { BIProvider };
//# sourceMappingURL=BIProvider.js.map